import { BenchmarkingReportSettings } from '@/hooks'

export const shouldDisplayWeatherSetting = (
    reportSettings: BenchmarkingReportSettings
) => {
    if (['cost', 'emission'].includes(reportSettings.basis)) {
        return false
    }

    return true
}
